export default {
  computed: {
    accessibleForecastLabel() {
      const temperatures = this.secondaryTemperature ?
        (`${this.$t('web.widgets.weather.temperature.daytime')} ${this.temperature}°, ` +
         `${this.$t('web.widgets.weather.temperature.nighttime')} ${this.secondaryTemperature}°`) :
        `${this.temperature}°`;
      return `${this.label} - ${this.description}, ${temperatures}`;
    },
  },
};
